export default __webpack_public_path__ + "static/media/zoom.732ad66c.webp";